module.exports = __webpack_public_path__ + "img/146-62-plan.25db5403.jpg";